export default __webpack_public_path__ + "static/media/EricEllenGerald.93d3cdc9.jpg";